import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { greenhouseCardMotion } from './motion';
import { greenhouseChromeTone } from './palette';

export const greenhouseTheme: FlowThemeDefinition = {
  id: 'greenhouse',
  label: 'Greenhouse',
  description: 'A Victorian glasshouse comes into flower: every answer unfurls seedlings, ferns, vines and blooms, until the garden thrives in golden light.',
  category: 'daylight',
  chromeTone: greenhouseChromeTone,
  swatch: 'linear-gradient(165deg, #CFE6F2 0%, #F3F6EC 35%, #9AD07A 60%, #4E9A58 78%, #CF7448 100%)',
  cardGlass: 'default',
  cardMotion: greenhouseCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createGreenhouseScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
